import { Component, ElementRef, HostListener, Inject, PLATFORM_ID, Input, OnDestroy, OnInit, Output, EventEmitter} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservationAdminService } from '../../../_services/api/reservation-admin.service';
import { NotificationService } from '../../../_services/app/notification.service';
import { MenuStateService } from '../../../_services/app/menu-state.service';
import { OfferWithActions, Agent } from '../../../_models/reservation.model';
import { OfferUtilsService } from '../../../_utils/offer-utils.service';
import { PriceFormatPipe } from '../../../_pipes/price_format.pipe';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { OfferAgentService } from '../../../_services/api/offer-agents.service';


@Component({
  selector: 'app-admin-reservation-offer-card',
  imports: [CommonModule, FormsModule, PriceFormatPipe],
  standalone: true,
  templateUrl: './admin-reservation-offer-card.component.html',
  styleUrl: './admin-reservation-offer-card.component.scss',
animations: [
    trigger('slideInOut', [
      state('open', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      state('closed', style({
        height: '0',
        opacity: 0,
        overflow: 'hidden'
      })),
      transition('open <=> closed', [
        animate('300ms ease-in-out')
      ])
    ]),
    trigger('rotateArrow', [
      state('open', style({
        transform: 'rotate(180deg)'
      })),
      state('closed', style({
        transform: 'rotate(0deg)'
      })),
      transition('open <=> closed', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class AdminReservationOfferCardComponent implements OnInit, OnDestroy {
  @Input() offer!: OfferWithActions;
  @Input() reservationId!: number;
  @Input() agentsExpanded: boolean = true;

  @Output() agentDeleted = new EventEmitter<void>();
  @Output() offerDeleted = new EventEmitter<void>();

  menuOpen = false;
  showDeleteModal = false;
  showDeleteOfferModal = false;
  showDeleteAgentModal = false;
  isAgentsExpanded = false;
  selectedAgent!: Agent | null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reservationService: ReservationAdminService,
    private agentReservationService: OfferAgentService,
    private offerUtils: OfferUtilsService,
    private notification: NotificationService,
    private elementRef: ElementRef, 
    private menuStateService: MenuStateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.isAgentsExpanded = this.agentsExpanded;
    this.menuStateService.activeMenu$.subscribe(activeId => {
      this.menuOpen = activeId === this.offer.id;
    });
      if (isPlatformBrowser(this.platformId)) {
        document.addEventListener('click', this.closeMenu.bind(this));
      }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
        document.removeEventListener('click', this.closeMenu.bind(this));
    }
  }

  toggleAgentsList(event: Event): void {
    event.stopPropagation();
    this.isAgentsExpanded = !this.isAgentsExpanded;
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    } else {
      this.menuStateService.setActiveMenu(this.offer.id);
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    }
  }
  

  getOfferStatusClass(): string {
    return this.offerUtils.getOfferStatusClass(this.offer.status as any);
  }

  getOfferStatusText(): string {
    return this.offerUtils.getOfferStatusText(this.offer.status as any);
  }

  editOffer(): void {
    this.router.navigate(['/admin/reservations', this.reservationId, 'offers', this.offer.id, 'edit']);    
  }

  manageOfferAgents(): void {
    this.router.navigate(['/admin/reservations', this.reservationId, 'offers', this.offer.id, 'agents']);
  }

  confirmDeleteOffer(): void {
    this.showDeleteOfferModal = true;
  }

  closeDeleteOfferModal(): void {
    this.showDeleteOfferModal = false;
  }

  deleteOffer(): void {
    if (!this.offer) return;
    this.reservationService.deleteOffer(this.offer.id).subscribe({
      next: () => {
        this.notification.showSuccess('Offre supprimée avec succès');
        this.closeDeleteOfferModal();
        this.offerDeleted.emit();
      },
      error: (error) => {
        console.error('Error deleting offer:', error);
        this.notification.showError('Erreur lors de la suppression de l\'offre');
        this.closeDeleteOfferModal();
      }
    });
  }

  confirmDeleteAgnet(agent: Agent): void {
    this.showDeleteAgentModal = true;
    this.selectedAgent = agent;
  }

  closeDeleteAgentModal(): void {
    this.showDeleteAgentModal = false;
    this.selectedAgent = null;
  }

  deleteAgent(): void {
    if (!this.offer || !this.selectedAgent) return;
    this.agentReservationService.removeAgentFromOffer(this.offer.id, this.selectedAgent.id).subscribe({
      next: () => {
        this.notification.showSuccess('Agent supprimé avec succès');
        this.closeDeleteAgentModal();
        this.agentDeleted.emit();
      },
      error: (error) => {
        console.error('Error deleting agent:', error);
        this.notification.showError('Erreur lors de la suppression d\'agent');
        this.closeDeleteAgentModal();
      }
    });
  }
}
